/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentResponseFormatDto
 */
export interface DocumentResponseFormatDto {
    /**
     * The document format
     * @type {string}
     * @memberof DocumentResponseFormatDto
     */
    responseFormat: DocumentResponseFormatDtoResponseFormatEnum;
}


/**
 * @export
 */
export const DocumentResponseFormatDtoResponseFormatEnum = {
    combined: 'combined',
    archive: 'archive',
    unknown_default_open_api: '11184809'
} as const;
export type DocumentResponseFormatDtoResponseFormatEnum = typeof DocumentResponseFormatDtoResponseFormatEnum[keyof typeof DocumentResponseFormatDtoResponseFormatEnum];


/**
 * Check if a given object implements the DocumentResponseFormatDto interface.
 */
export function instanceOfDocumentResponseFormatDto(value: object): boolean {
    if (!('responseFormat' in value)) return false;
    return true;
}

export function DocumentResponseFormatDtoFromJSON(json: any): DocumentResponseFormatDto {
    return DocumentResponseFormatDtoFromJSONTyped(json, false);
}

export function DocumentResponseFormatDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentResponseFormatDto {
    if (json == null) {
        return json;
    }
    return {
        
        'responseFormat': json['responseFormat'],
    };
}

export function DocumentResponseFormatDtoToJSON(value?: DocumentResponseFormatDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'responseFormat': value['responseFormat'],
    };
}

